import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/route-loading.css';

const RouteLoadingScreen = ({ labelKey = 'layout.appLoading' }) => {
  const { t } = useTranslation();
  return (
    <div className="route-loading-screen" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <p className="route-loading-screen__label">{t(labelKey)}</p>
    </div>
  );
};

export default RouteLoadingScreen;
